module.exports = __webpack_public_path__ + "hinted-Montserrat-Italic.1864408aeed8373ef420.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-Italic.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-Italic.woff
// module chunks = 1